import styled from '@emotion/styled';

export const SadaServiceLink = styled.div``;
